import type { InternalContentType } from '@/types/donation';

/**
 * Get the route path for internal content types.
 * Used for navigating to specific content after clicking donation badge.
 */
export function getContentRoute(type: InternalContentType, id: string): string {
  switch (type) {
    case 'material':
      // Navigate to library with the material highlighted
      return `/library?highlight=${id}`;
    case 'post':
      // Navigate to community chat with the message highlighted
      return `/chat/community?message=${id}`;
    case 'prayer':
      // Navigate to prayers with the prayer highlighted
      return `/prayers?highlight=${id}`;
    default:
      return '/';
  }
}

/**
 * Get a human-readable label for content types.
 */
export function getContentTypeLabel(type: InternalContentType): string {
  switch (type) {
    case 'material':
      return 'Library Material';
    case 'post':
      return 'Community Post';
    case 'prayer':
      return 'Prayer';
    default: {
      // Exhaustive check: if a new type is added, TypeScript will flag this
      const _exhaustive: never = type;
      return String(_exhaustive) || 'Unknown';
    }
  }
}
